export { VALIDATOR_TYPE, numericValidator } from "./numericValidator.mjs";


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/validators/numericValidator/index.mjs
// module id = 598
// module chunks = 1